export default __webpack_public_path__ + "static/media/credit-card-solid.99dc9595.svg";